<template>
  <page>
    <template slot="content">
    <help-content :title="'睡眠目標の設定変更による影響について'">
      <template slot="content">
        <div class="text">
          就寝・起床時刻を変更する時に、まれに前日の睡眠実績に影響します。影響を与えないために、すでに設定されている就寝〜起床時刻以外の時間に操作してください。<br><br>
          過去の睡眠状況と比較するために、<b>予定の睡眠時間より少し多めに就寝・起床時刻を設定し、頻繁に時刻の設定を変更しないこと</b>をおすすめします。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help27.vue